import { Formik, Form, ErrorMessage } from 'formik';
import * as yup from 'yup';
import { $t } from 'hooks/i18n';
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { DataSource } from 'components/DataSource';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { PageRequestError } from 'components/PageRequestError';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Title } from 'components/Title';
import useApp from 'hooks/useApp';
import useUtils from 'hooks/useUtils';

import useEditPage from 'hooks/useEditPage';
const MandatedepositEditPage = (props) => {
		const app = useApp();
	const utils = useUtils();
	// form validation schema
	const validationSchema = yup.object().shape({
		policyno: yup.string().required().label($t('policyNo')),
		accountholdername: yup.string().required().label($t('accountHolderName')),
		accountnumber: yup.string().required().label($t('accountNumber')),
		amounttype: yup.string().required().label($t('amountType')),
		accounttype: yup.string().required().label($t('accountType')),
		authtype: yup.string().required().label($t('authType')),
		bankifsc: yup.string().required().label($t('bankIfsc')),
		collectionamount: yup.string().required().label($t('collectionAmount')),
		customeremail: yup.string().email().required().label($t('customerEmail')),
		customermobile: yup.string().required().label($t('customerMobile')),
		customername: yup.string().required().label($t('customerName')),
		firstcollectiondate: yup.string().required().label($t('firstCollectionDate')),
		frequency: yup.string().required().label($t('frequency')),
		lastcollectiondate: yup.string().required().label($t('lastCollectionDate')),
		merchanttrxnrefid: yup.string().nullable().label($t('merchanTtrxnRefid')),
		principalamount: yup.string().required().label($t('principalamount')),
		bankcode: yup.string().nullable().label($t('bankcode')),
		trxnid: yup.string().nullable().label($t('trxnid')),
		status: yup.string().nullable().label($t('status')),
		authorized: yup.string().nullable().label($t('authorized')),
		cancelled: yup.string().nullable().label($t('cancelled')),
		mdate: yup.string().nullable().label($t('mdate')),
		mandate_id: yup.string().nullable().label($t('mandateId')),
		paymentmethod_token: yup.string().nullable().label($t('paymentmethodToken')),
		instrumenttoken: yup.string().nullable().label($t('instrumenttoken'))
	});
	// form default values
	const formDefaultValues = {
		policyno: '', 
		accountholdername: '', 
		accountnumber: '', 
		amounttype: "M", 
		accounttype: '', 
		authtype: '', 
		bankifsc: '', 
		collectionamount: '', 
		customeremail: '', 
		customermobile: '', 
		customername: '', 
		firstcollectiondate: '', 
		frequency: '', 
		lastcollectiondate: '', 
		merchanttrxnrefid: utils.randomNum(8), 
		principalamount: '', 
		bankcode: '', 
		trxnid: utils.randomNum(10), 
		status: '', 
		authorized: '', 
		cancelled: '', 
		mdate: new Date(), 
		mandate_id: new Date(), 
		paymentmethod_token: '', 
		instrumenttoken: '', 
	}
	//where page logics resides
	const pageController = useEditPage({ props, formDefaultValues, afterSubmit });
	//destructure and grab what we need
	const { formData, handleSubmit, submitForm, pageReady, loading, saving, apiRequestError, inputClassName } = pageController
	//Event raised on form submit success
	function afterSubmit(response){
		app.flashMsg(props.msgTitle, props.msgAfterSave);
		if(app.isDialogOpen()){
			app.closeDialogs(); // if page is open as dialog, close dialog
		}
		else if(props.redirect) {
			app.navigate(`/mandatedeposit`);
		}
	}
	// loading form data from api
	if(loading){
		return (
			<div className="p-3 text-center">
				<ProgressSpinner style={{width:'50px', height:'50px'}} />
			</div>
		);
	}
	//display error page 
	if(apiRequestError){
		return (
			<PageRequestError error={apiRequestError} />
		);
	}
	//page is ready when formdata loaded successfully
	if(pageReady){
		return (
<main id="MandatedepositEditPage" className="main-page">
    { (props.showHeader) && 
    <section className="page-section mb-3" >
        <div className="container">
            <div className="grid justify-content-between align-items-center">
                { !props.isSubPage && 
                <div className="col-fixed " >
                    <Button onClick={() => app.navigate(-1)} label={$t('')}  className="p-button p-button-text " icon="pi pi-arrow-left"  />
                </div>
                }
                <div className="col " >
                    <Title title={$t('editMandatedeposit')}   titleClass="text-2xl text-primary font-bold" subTitleClass="text-500"      separator={false} />
                </div>
            </div>
        </div>
    </section>
    }
    <section className="page-section " >
        <div className="container">
            <div className="grid ">
                <div className="md:col-9 sm:col-12 comp-grid" >
                    <div >
                        <Formik
                            initialValues={formData}
                            validationSchema={validationSchema} 
                            onSubmit={(values, actions) => {
                            submitForm(values);
                            }
                            }
                            >
                            { (formik) => {
                            return (
                            <Form className={`${!props.isSubPage ? 'card  ' : ''}`}>
                                <div className="grid">
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('policyNo')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/policyno_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="policyno"     optionLabel="label" optionValue="value" value={formik.values.policyno} onChange={formik.handleChange} options={response} label={$t('policyNo')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.policyno)}   />
                                                    <ErrorMessage name="policyno" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountHolderName')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountholdername"  onChange={formik.handleChange}  value={formik.values.accountholdername}   label={$t('accountHolderName')} type="text" placeholder={$t('enterAccountHolderName')}        className={inputClassName(formik?.errors?.accountholdername)} />
                                                <ErrorMessage name="accountholdername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountNumber')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="accountnumber"  onChange={formik.handleChange}  value={formik.values.accountnumber}   label={$t('accountNumber')} type="text" placeholder={$t('enterAccountNumber')}        className={inputClassName(formik?.errors?.accountnumber)} />
                                                <ErrorMessage name="accountnumber" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('amountType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="amounttype"  onChange={formik.handleChange}  value={formik.values.amounttype}   label={$t('amountType')} type="text" placeholder={$t('enterAmountType')}     disabled   className={inputClassName(formik?.errors?.amounttype)} />
                                                <ErrorMessage name="amounttype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('accountType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="accounttype"     optionLabel="label" optionValue="value" value={formik.values.accounttype} onChange={formik.handleChange} options={app.menus.accounttype} label={$t('accountType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.accounttype)}   />
                                                <ErrorMessage name="accounttype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('authType')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Dropdown  name="authtype"     optionLabel="label" optionValue="value" value={formik.values.authtype} onChange={formik.handleChange} options={app.menus.authtype} label={$t('authType')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.authtype)}   />
                                                <ErrorMessage name="authtype" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankIfsc')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="bankifsc"  onChange={formik.handleChange}  value={formik.values.bankifsc}   label={$t('bankIfsc')} type="text" placeholder={$t('enterBankIfsc')}        className={inputClassName(formik?.errors?.bankifsc)} />
                                                <ErrorMessage name="bankifsc" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('collectionAmount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="collectionamount"  onChange={formik.handleChange}  value={formik.values.collectionamount}   label={$t('collectionAmount')} type="text" placeholder={$t('enterCollectionAmount')}        className={inputClassName(formik?.errors?.collectionamount)} />
                                                <ErrorMessage name="collectionamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('customerEmail')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customeremail"  onChange={formik.handleChange}  value={formik.values.customeremail}   label={$t('customerEmail')} type="email" placeholder={$t('enterCustomerEmail')}        className={inputClassName(formik?.errors?.customeremail)} />
                                                <ErrorMessage name="customeremail" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('customerMobile')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customermobile"  onChange={formik.handleChange}  value={formik.values.customermobile}   label={$t('customerMobile')} type="text" placeholder={$t('enterCustomerMobile')}        className={inputClassName(formik?.errors?.customermobile)} />
                                                <ErrorMessage name="customermobile" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('customerName')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="customername"  onChange={formik.handleChange}  value={formik.values.customername}   label={$t('customerName')} type="text" placeholder={$t('enterCustomerName')}        className={inputClassName(formik?.errors?.customername)} />
                                                <ErrorMessage name="customername" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('firstCollectionDate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="firstcollectiondate"  onChange={formik.handleChange}  value={formik.values.firstcollectiondate}   label={$t('firstCollectionDate')} type="text" placeholder={$t('enterFirstCollectionDate')}        className={inputClassName(formik?.errors?.firstcollectiondate)} />
                                                <ErrorMessage name="firstcollectiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('frequency')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/frequency_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="frequency"     optionLabel="label" optionValue="value" value={formik.values.frequency} onChange={formik.handleChange} options={response} label={$t('frequency')}  placeholder={$t('selectAValue')}  className={inputClassName(formik?.errors?.frequency)}   />
                                                    <ErrorMessage name="frequency" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('lastCollectionDate')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="lastcollectiondate"  onChange={formik.handleChange}  value={formik.values.lastcollectiondate}   label={$t('lastCollectionDate')} type="text" placeholder={$t('enterLastCollectionDate')}        className={inputClassName(formik?.errors?.lastcollectiondate)} />
                                                <ErrorMessage name="lastcollectiondate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('merchanTtrxnRefid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="merchanttrxnrefid"  onChange={formik.handleChange}  value={formik.values.merchanttrxnrefid}   label={$t('merchanTtrxnRefid')} type="text" placeholder={$t('enterMerchanTtrxnRefid')}     disabled   className={inputClassName(formik?.errors?.merchanttrxnrefid)} />
                                                <ErrorMessage name="merchanttrxnrefid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('principalamount')} *
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="principalamount"  onChange={formik.handleChange}  value={formik.values.principalamount}   label={$t('principalamount')} type="text" placeholder={$t('enterPrincipalamount')}        className={inputClassName(formik?.errors?.principalamount)} />
                                                <ErrorMessage name="principalamount" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('bankcode')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <DataSource   apiPath="components_data/bankcode_option_list"  >
                                                    {
                                                    ({ response }) => 
                                                    <>
                                                    <Dropdown  name="bankcode"     optionLabel="label" optionValue="value" value={formik.values.bankcode} onChange={formik.handleChange} options={response} label={$t('bankcode')}  placeholder={$t('selectAValue')} filter={true} className={inputClassName(formik?.errors?.bankcode)}   />
                                                    <ErrorMessage name="bankcode" component="span" className="p-error" />
                                                    </>
                                                    }
                                                </DataSource>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('trxnid')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="trxnid"  onChange={formik.handleChange}  value={formik.values.trxnid}   label={$t('trxnid')} type="text" placeholder={$t('enterTrxnid')}        className={inputClassName(formik?.errors?.trxnid)} />
                                                <ErrorMessage name="trxnid" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('status')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="status"  onChange={formik.handleChange}  value={formik.values.status}   label={$t('status')} type="text" placeholder={$t('enterStatus')}        className={inputClassName(formik?.errors?.status)} />
                                                <ErrorMessage name="status" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('authorized')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="authorized"  onChange={formik.handleChange}  value={formik.values.authorized}   label={$t('authorized')} type="text" placeholder={$t('enterAuthorized')}        className={inputClassName(formik?.errors?.authorized)} />
                                                <ErrorMessage name="authorized" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('cancelled')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="cancelled"  onChange={formik.handleChange}  value={formik.values.cancelled}   label={$t('cancelled')} type="text" placeholder={$t('enterCancelled')}        className={inputClassName(formik?.errors?.cancelled)} />
                                                <ErrorMessage name="cancelled" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mdate')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="mdate" showButtonBar className={inputClassName(formik?.errors?.mdate)} dateFormat="yy-mm-dd" value={formik.values.mdate} onChange={formik.handleChange} showIcon     disabled   />
                                                <ErrorMessage name="mdate" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="md:col-6 col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('mandateId')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <Calendar name="mandate_id" value={formik.values.mandate_id} onChange={formik.handleChange} showButtonBar showTime dateFormat="yy-mm-dd" hourFormat="24"showIcon className={inputClassName(formik?.errors?.mandate_id)}     disabled   />
                                                <ErrorMessage name="mandate_id" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('paymentmethodToken')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="paymentmethod_token"  onChange={formik.handleChange}  value={formik.values.paymentmethod_token}   label={$t('paymentmethodToken')} type="text" placeholder={$t('enterPaymentmethodToken')}        className={inputClassName(formik?.errors?.paymentmethod_token)} />
                                                <ErrorMessage name="paymentmethod_token" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-12">
                                        <div className="formgrid grid">
                                            <div className="col-12 md:col-3">
                                                {$t('instrumenttoken')} 
                                            </div>
                                            <div className="col-12 md:col-9">
                                                <InputText name="instrumenttoken"  onChange={formik.handleChange}  value={formik.values.instrumenttoken}   label={$t('instrumenttoken')} type="text" placeholder={$t('enterInstrumenttoken')}        className={inputClassName(formik?.errors?.instrumenttoken)} />
                                                <ErrorMessage name="instrumenttoken" component="span" className="p-error" />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                { props.showFooter && 
                                <div className="text-center my-3">
                                    <Button onClick={(e) => handleSubmit(e, formik)}  type="submit" label={$t('update')} icon="pi pi-send" loading={saving} />
                                </div>
                                }
                            </Form>
                            );
                            }
                            }
                            </Formik>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </main>
		);
	}
}
MandatedepositEditPage.defaultProps = {
	primaryKey: 'mdid',
	pageName: 'mandatedeposit',
	apiPath: 'mandatedeposit/edit',
	routeName: 'mandatedepositedit',
	submitButtonLabel: $t('update'),
	formValidationError: $t('formIsInvalid'),
	formValidationMsg: $t('pleaseCompleteTheForm'),
	msgTitle: $t('updateRecord'),
	msgAfterSave: $t('recordUpdatedSuccessfully'),
	msgBeforeSave: $t(''),
	showHeader: true,
	showFooter: true,
	redirect: true,
	isSubPage: false
}
export default MandatedepositEditPage;
